<template>
  <div>
    <va-modal
      class="modal activity"
      v-model="modalValue"
      max-width="100%"
      hideDefaultActions
      noEscDismiss
      noOutsideDismiss
    >
      <div class="forcewidth">
        <h1>Création d'une formation</h1>
        <div class="row row-inside">
          <div class="flex md12">
            <div class="row row-inside">
              <div class="flex md8 pa-2">
                <va-select
                  label="Type de formation"
                  textBy="desc"
                  keyBy="idformation_types"
                  v-model="newFormation.type"
                  :options="formationTypes"
                  :error="errors.type"
                />
              </div>
              <div class="flex md4 pa-2">
                <va-date-picker
                  label="Date de la formation"
                  :config="{ dateFormat: 'd-m-Y' }"
                  v-model="newFormation.date"
                  :error="errors.date"
                />
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md12 pa-2">
                <va-checkbox
                  label="Inter-entreprise"
                  v-model="newFormation.inter"
                />
              </div>
            </div>
            <div
              class="row row-inside"
              v-if="!newFormation.inter"
            >
              <div class="flex md6 pa-2">
                <h3>Entreprise base OPEF</h3>
                <va-input
                  v-model="searchQueryOpef"
                  placeholder="Entrez au moins 3 caractères pour rechercher"
                  @input="onSearchOpefChange"
                  clearable
                >
                  <va-icon name="fa fa-search" slot="prepend" />
                </va-input>
                <va-select
                  :disabled="entrepriseAfpfSelect !== '' || searchQueryOpef.length < 3"
                  class="my-4"
                  label="Selection de l'entreprise"
                  key-by="identreprise"
                  text-by="displayText"
                  :options="listeEntreprises"
                  placeholder="Sélectionnez une entreprise"
                  v-model="entrepriseSelect"
                  :error="errors.entreprise"
                />
              </div>
              <div class="flex md6 pa-2">
                <h3>Entreprise base AFPF</h3>
                <va-input
                  v-model="searchQueryAfpf"
                  placeholder="Entrez au moins 3 caractères pour rechercher"
                  @input="onSearchAfpfChange"
                  clearable
                >
                  <va-icon name="fa fa-search" slot="prepend" />
                </va-input>
                <va-select
                  :disabled="entrepriseSelect !== '' || searchQueryAfpf.length < 3"
                  class="my-4"
                  label="Selection de l'entreprise"
                  key-by="identreprise"
                  text-by="displayText"
                  :options="listeEntreprisesAFPF"
                  placeholder="Sélectionnez une entreprise"
                  v-model="entrepriseAfpfSelect"
                  :error="errors.entreprise"
                />
              </div>
              <div class="flex md12 pa-2">
                <div class="row row-inside align--center">
                  <div class="flex md4">
                    <va-checkbox
                      label="Utiliser l'adresse de l'entreprise"
                      v-model="useEntrepriseAdresse"
                    />
                  </div>
                  <div class="flex md8">
                    <p class="entreprise-adresse">
                      {{ entrepriseAdresseLabel }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row row-inside" v-if="newFormation.inter || !useEntrepriseAdresse">
              <div class="flex md8 pa-2">
                <va-select
                  label="Lieu de la formation"
                  searchable
                  textBy="desc"
                  keyBy="idformation_lieux"
                  v-model="newFormation.lieu"
                  :options="listeLieux"
                  :error="errors.lieu"
                />
              </div>
              <div class="flex md4 pa-2">
                <va-button
                  class="create-button"
                  @click="showCreateLieux = true"
                  color="info"
                >
                  <va-icon
                    size="20px"
                    name="fa fa-plus"
                  />
                </va-button>
              </div>
              <div
                class="flex md12 pa-2"
                v-if="newFormation.lieu"
              >
                <p>
                  {{ newFormation.lieu.nom }} - {{ newFormation.lieu.adresse}} <span v-if="newFormation.lieu.complement"> - {{newFormation.lieu.complement}}</span></br>
                  {{ newFormation.lieu.code_postal }} - {{ newFormation.lieu.ville }} <span v-if="newFormation.lieu.cedex"> - Cedex {{newFormation.lieu.cedex}}</span>
                </p>
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md8 pa-2">
                <va-select
                  label="Formateur"
                  searchable
                  textBy="desc"
                  keyBy="idformation_formateurs"
                  v-model="newFormation.formateur"
                  :options="listeFormateurs"
                  :error="errors.formateur"
                />
              </div>
              <div class="flex md4 pa-2">
                <va-button
                  class="create-button"
                  @click="showCreateFormateurs = true"
                  color="info"
                >
                  <va-icon
                    size="20px"
                    name="fa fa-plus"
                  />
                </va-button>
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md12 pa-2">
                <va-input
                  label="Commentaires"
                  type="textarea"
                  autosize
                  :minRows="5"
                  v-model="newFormation.commentaires"
                />
              </div>

            </div>

          </div>
        </div>
      </div>
      <template v-slot:actions>
        <div class="va-modal__actions mb-3">
          <va-button color="gray" flat @click="closeModal">Annuler</va-button>
          <va-button @click="saveFormation">Créer la formation</va-button>
        </div>
      </template>
    </va-modal>
    <create-lieux v-model="showCreateLieux" />
    <create-formateur v-model="showCreateFormateurs" />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import createLieux from "./create-lieux.vue";
import createFormateur from "./create-formateur.vue";
import { get } from "lodash";

export default {
  props: ["value"],
  components: {
    "create-lieux": createLieux,
    "create-formateur": createFormateur,
  },
  data() {
    return {
      showCreateFormation: false,
      saveMessage: "Enregistrer",
      formationTypes: [],
      listeLieux: [],
      listeFormateurs: [],
      showCreateLieux: false,
      showCreateFormateurs: false,
      errors: {
        type: false,
        date: false,
        entreprise: false,
        lieu: false,
        formateur: false,
      },
      newFormation: {
        date: moment().format("DD-MM-YYYY"),
        lieu: "",
        inter: true,
        type: "",
        formateur: "",
        commentaires: null,
      },
      listeEntreprises: [],
      listeEntreprisesAFPF: [],
      entrepriseSelect: "",
      entrepriseAfpfSelect: "",
      searchQueryOpef: "",
      searchQueryAfpf: "",
      searchTimeoutOpef: null,
      searchTimeoutAfpf: null,
      useEntrepriseAdresse: true,
      entrepriseAdresseDetails: null,
      isLoadingEntrepriseAdresse: false,

    };
  },
  mounted() {
    this.showCreateFormation = this.value;
    this.getFormationType();
    this.getListeLieux();
    this.getFormateurs();
  },
  watch: {
    showCreateFormateurs() {
      this.getFormateurs();
    },
    showCreateLieux() {
      this.getListeLieux();
    },
    value() {
      this.showCreateFormation = this.value;
      if (this.value) {
        this.resetForm();
      }
    },
    "newFormation.inter"(newValue) {
      if (!newValue) {
        this.useEntrepriseAdresse = true;
      }
    },
    useEntrepriseAdresse(newValue) {
      if (newValue && !this.newFormation.inter) {
        this.newFormation.lieu = "";
      }
    },
    entrepriseSelect(newValue) {
      if (newValue && newValue.identreprise) {
        this.loadEntrepriseAdresse(newValue.identreprise);
      } else if (!this.entrepriseAfpfSelect) {
        this.entrepriseAdresseDetails = null;
      }
    },
    entrepriseAfpfSelect(newValue) {
      if (newValue && newValue.identreprise) {
        this.loadEntrepriseAdresse(newValue.identreprise);
      } else if (!this.entrepriseSelect) {
        this.entrepriseAdresseDetails = null;
      }
    },
  },
  computed: {
    modalValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    selectedEntreprise() {
      if (this.entrepriseSelect && this.entrepriseSelect !== "") {
        return this.entrepriseSelect;
      }
      if (this.entrepriseAfpfSelect && this.entrepriseAfpfSelect !== "") {
        return this.entrepriseAfpfSelect;
      }
      return null;
    },
    entrepriseAdresseLabel() {
      if (this.isLoadingEntrepriseAdresse) {
        return "Chargement de l'adresse...";
      }
      const ent = this.entrepriseAdresseDetails || this.selectedEntreprise;
      if (!ent) return "Adresse entreprise non sélectionnée";
      const adresse = ent.adresse || ent.adresse_siege || ent.adresse_siege_nom;
      const complement = ent.complement || ent.adresse_complement;
      const cp = ent.code_postal || ent.cp || ent.code_postal_siege;
      const ville = ent.ville || ent.ville_siege;
      const cedex = ent.cedex || ent.cedex_siege;
      const line1 = [adresse, complement].filter(Boolean).join(" - ");
      const line2 = [cp, ville, cedex ? `Cedex ${cedex}` : ""]
        .filter(Boolean)
        .join(" ");
      const label = [line1, line2].filter(Boolean).join(" / ");
      return label || "Adresse entreprise indisponible";
    },
  },
  methods: {
    resetForm() {
      this.resetErrors();
      this.newFormation = {
        date: moment().format("DD-MM-YYYY"),
        lieu: "",
        inter: true,
        type: "",
        formateur: "",
        commentaires: null,
      };
      this.entrepriseSelect = "";
      this.entrepriseAfpfSelect = "";
      this.useEntrepriseAdresse = true;
      this.entrepriseAdresseDetails = null;
      this.isLoadingEntrepriseAdresse = false;
    },
    resetErrors() {
      this.errors = {
        type: false,
        date: false,
        entreprise: false,
        lieu: false,
        formateur: false,
      };
    },
    async loadEntrepriseAdresse(identreprise) {
      this.isLoadingEntrepriseAdresse = true;
      try {
        const response = await axios.get("/api/entreprise-infos", {
          params: { id: identreprise },
        });
        const etablissement = response.data && response.data.etablissement
          ? response.data.etablissement
          : {};
        const adresse = etablissement.adress || etablissement.adresse || null;
        this.entrepriseAdresseDetails = adresse;
      } catch (error) {
        console.log(error);
        this.entrepriseAdresseDetails = null;
        this.launchEpicmaxToast(
          "Erreur lors de la récupération de l'adresse de l'entreprise"
        );
      } finally {
        this.isLoadingEntrepriseAdresse = false;
      }
    },

    closeModal() {
      this.$emit("input", false);
    },
    async searchEntreprises(query, isAfpf = false) {
      if (query.length < 3) {
        if (isAfpf) {
          this.listeEntreprisesAFPF = [];
        } else {
          this.listeEntreprises = [];
        }
        return;
      }
      try {
        let res;
        if (isAfpf) {
          // For AFPF, check if the endpoint supports search parameter
          res = await axios.get("/api/afpf/liste-entreprises-selection-afpf", {
            params: { search: query }
          });
          const data = res.data.listeEntreprise || res.data;
          const enrichedData = data.map(entreprise => ({
            ...entreprise,
          displayText: `${entreprise.nom} (${entreprise.siret}; ${entreprise.code_postal}  ${entreprise.ville}; ${entreprise.gerant})`
          }));
          this.listeEntreprisesAFPF = enrichedData;
        } else {
          // For OPEF, use the find-entreprise endpoint which supports search
          res = await axios.get("api/entreprises/find-entreprise", {
            params: { search: query }
          });
          const enrichedData = res.data.map(entreprise => ({
            ...entreprise,
          displayText: `${entreprise.nom} (${entreprise.siret}; ${entreprise.code_postal}  ${entreprise.ville}; ${entreprise.gerant})`
          }));
          this.listeEntreprises = enrichedData;
        }
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la recherche d'entreprise");
      }
    },
    onSearchOpefChange(query) {
      // Clear existing timeout
      if (this.searchTimeoutOpef) {
        clearTimeout(this.searchTimeoutOpef);
      }
      
      // Set new timeout to debounce search requests
      this.searchTimeoutOpef = setTimeout(() => {
        this.searchEntreprises(query, false);
      }, 300);
    },
    onSearchAfpfChange(query) {
      // Clear existing timeout
      if (this.searchTimeoutAfpf) {
        clearTimeout(this.searchTimeoutAfpf);
      }
      
      // Set new timeout to debounce search requests
      this.searchTimeoutAfpf = setTimeout(() => {
        this.searchEntreprises(query, true);
      }, 300);
    },
    saveFormation() {
      this.resetErrors();
      this.errors.type = !this.newFormation.type;
      this.errors.date = !this.newFormation.date;
      if (!this.newFormation.inter) {
        this.errors.entreprise =
          this.entrepriseSelect === "" && this.entrepriseAfpfSelect === "";
      }
      this.errors.formateur = !this.newFormation.formateur;
      if (this.newFormation.inter) {
        this.errors.lieu = !this.newFormation.lieu;
      } else {
        this.errors.lieu = !this.newFormation.lieu && !this.useEntrepriseAdresse;
      }

      const hasErrors = Object.values(this.errors).some(Boolean);
      if (!hasErrors) {
        if (!this.newFormation.inter && this.entrepriseSelect === "" && this.entrepriseAfpfSelect === "") {
          this.launchEpicmaxToast("Veuillez sélectionner une entreprise pour une formation intra");
          this.$nextTick(() => {
            this.$emit("input", true);
          });
          return;
        }
        if (!this.newFormation.formateur) {
          this.launchEpicmaxToast("Veuillez sélectionner un formateur");
          this.$nextTick(() => {
            this.$emit("input", true);
          });
          return;
        }
        if (!this.newFormation.lieu && !this.useEntrepriseAdresse) {
          this.launchEpicmaxToast("Veuillez sélectionner un lieu ou utiliser l'adresse de l'entreprise");
          this.$nextTick(() => {
            this.$emit("input", true);
          });
          return;
        }
        if (this.newFormation.inter && !this.newFormation.lieu) {
          this.launchEpicmaxToast("Veuillez sélectionner un lieu");
          this.$nextTick(() => {
            this.$emit("input", true);
          });
          return;
        }
        let formation = {
          date: moment(this.newFormation.date, "DD-MM-YYYY").format("YYYY-MM-DD"),
          idtype: this.newFormation.type.idformation_types,
          idlieu: this.newFormation.lieu ? this.newFormation.lieu.idformation_lieux : null,
          inter: this.newFormation.inter,
          idformateur: this.newFormation.formateur.idformation_formateurs,
          commentaires: this.newFormation.commentaires,
        };

        if (!this.newFormation.inter) {
          formation.identreprise = this.entrepriseSelect !== "" ? this.entrepriseSelect.identreprise : this.entrepriseAfpfSelect.identreprise;
        }

        axios.post("/api/afpf/formation", formation)
          .then(response => {
            this.launchEpicmaxToast("Formation créée avec succès");
            this.$emit("create", response.data.idformation);
            this.closeModal();
          })
          .catch(() => {
            this.launchEpicmaxToast("Erreur lors de l'enregistrement de la formation");
          });
      } else {
        this.launchEpicmaxToast("Veuillez remplir les champs obligatoires");
        this.$nextTick(() => {
          this.$emit("input", true);
        });
      }
    },
    async getListeLieux() {
      try {
        const response = await axios.get("/api/afpf/liste-lieux");
        response.data.forEach(element => {
          element.desc = element.nom + " (" + element.code_postal + " - " + element.ville + ")";
        });
        this.$set(this, 'listeLieux', response.data);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la récupération des lieux");
      }
    },
    async getFormationType() {
      try {
        const response = await axios.get("/api/afpf/formation-type");
        response.data.forEach(element => {
          element.desc = element.name + " (" + element.shortname + ")";
        });
        this.$set(this, 'formationTypes', response.data);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la récupération des types de formation");
      }

    },
    async getFormateurs() {
      try {
        const response = await axios.get("/api/afpf/liste-formateurs");
        response.data.forEach(element => {
          element.desc = element.titre + " " + element.nom + " " + element.prenom;
        });
        this.$set(this, 'listeFormateurs', response.data);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la récupération des formateurs");
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },

  },
}
</script>

<style scoped>
.forcewidth {
  width: 40vw;
  height: 60vh;
  overflow: auto;
}
</style>
